import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async';
import { ROUTE_GROUPS } from '@atlassian/jira-common-constants/src/spa-routes';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async';
import { type Route, createEntry } from '@atlassian/jira-router';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info';
import { jsmEmailDomainsListResource } from '@atlassian/jira-router-resources-jsm-get-email-domains-list';
import { productsJsmOrganizationDetailsResource } from '@atlassian/jira-router-resources-jsm-organization-details';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@atlassian/jira-router-resources-service-desk-common';
import {
	entitlementsOrganizationQueryResource,
	uiOrganizationDetailsPageQueryResource,
} from '@atlassian/jira-router-resources-service-desk-customer-service-organization-details';
import {
	servicedeskOrganizationsRoute,
	servicedeskOrganizationDetailsRoute,
} from '@atlassian/jira-router-routes-servicedesk-organizations-routes';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout';
import { APP_NAMES, toPackageName } from '@atlassian/jira-servicedesk-common/src/utils/app-names';
import {
	ServiceDeskOrganizations,
	LazyServicedeskOrganizations,
	ServicedeskOrganizationDetails,
	LazyServicedeskOrganizationDetails,
} from './ui';

export { ServiceDeskOrganizations };

const getOrganizationsRoutesCommon = () => ({
	group: ROUTE_GROUPS.SERVICEDESK,
	exact: true,
	layout: serviceProjectLayout,
	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarServicedesk,
	},
	resources: [
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		getConsolidationStateResource(),
	],
});

export const organizationsRouteEntries: Route[] = [
	createEntry(servicedeskOrganizationsRoute, {
		...getOrganizationsRoutesCommon(),
		component: ServiceDeskOrganizations,
		forPaint: [LazyAtlassianNavigation, LazyServicedeskOrganizations],
		perfMetricKey: 'jsm-organizations-component-load',

		meta: {
			reporting: {
				id: APP_NAMES.ORGANIZATIONS,
				packageName: toPackageName(APP_NAMES.ORGANIZATIONS),
				teamName: 'boysenberry',
			},
		},
	}),
	createEntry(servicedeskOrganizationDetailsRoute, {
		...getOrganizationsRoutesCommon(),
		component: ServicedeskOrganizationDetails,
		forPaint: [LazyAtlassianNavigation, LazyServicedeskOrganizationDetails],
		perfMetricKey: 'jsm-organization-details-component-load',

		meta: {
			reporting: {
				id: APP_NAMES.ORGANIZATION_DETAILS,
				packageName: toPackageName(APP_NAMES.ORGANIZATION_DETAILS),
				teamName: 'boysenberry',
			},
		},

		resources: [
			...getOrganizationsRoutesCommon().resources,
			entitlementsOrganizationQueryResource,
			uiOrganizationDetailsPageQueryResource,
			productsJsmOrganizationDetailsResource,
			jsmEmailDomainsListResource,
		],
	}),
];
